export default __webpack_public_path__ + "static/media/Academiq-logo.8bc55788.svg";